import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import logger from "../util/logger";
import * as _ from "../util/lodash";

function isStateless(Component) {
  return !_.has(Component, 'prototype.render');
}
/**
 * @param  {ReactComponent|[ReactComponent]} Component -
 *    The type you expect the Element to be. Can be an array of Components or a single Component
 * @param  {ReactElement} Element - The element you are asserting on
 */


function isType(Component, element) {
  logger.warn("\"element\" is null. This is likely due to a conditional render (e.g. { someCondition && <MyElement> }).\n This can often lead to bugs. You probably want to strip out null values. React.Children.toArray can do this.", _.isNil(element));

  var _Components = _.isArray(Component) ? Component : [Component];

  return _someInstanceProperty(_).call(_, _Components, function (_Component) {
    return element && element.type === _Component;
  });
}

export default {
  isStateless: isStateless,
  isType: isType
};
//# sourceMappingURL=utils.js.map